import { PaperPlaneTilt, Images } from "@phosphor-icons/react";

/**
 * V9.35 — Inline confirmation chip rendered below the assistant
 * bubble when the LLM successfully called `send_visual_to_contact`.
 *
 * Visual language mirrors `TaskDelegatedChip` (cyan, pill, icon
 * left) but with a multi-image glyph instead of a paper-plane so
 * the user instantly reads it as "media dispatch" not "Q&A
 * delegation".
 *
 * NOTE: "Sent" here means DISPATCHED to Twilio — not yet confirmed
 * delivered to the contact's phone. We deliberately do not promise
 * delivery in the chip copy; the system prompt also instructs the
 * LLM to use careful tense.
 */
export default function VisualSentChip({ result }) {
  if (!result) return null;
  const name = result.contact_name || "contact";
  const count = result.step_count || 0;
  return (
    <div
      className="mt-2 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/30 text-xs text-cyan-300"
      data-testid={`visual-sent-chip-${result.contact_id || "x"}`}
    >
      <Images size={12} weight="duotone" className="text-cyan-400" />
      <span>
        Sent visual to{" "}
        <span className="text-cyan-200 font-medium">{name}</span>
        {count ? ` · ${count} ${count === 1 ? "card" : "cards"}` : ""}
      </span>
      <PaperPlaneTilt size={10} weight="bold" className="text-cyan-400/70" />
    </div>
  );
}
